// # Quick Order

define('modules/QuickOrder/QuickOrder',[
    'jquery',
    'global/all',
    '../Cart/all'

], function ($, Roc, Cart) {
    'use strict';
    var viewModel = {};
    var limit = 10;
    var apiUrl = null;
    var baseUrl = null; 

    viewModel.Order = [];

    var forms = {
        QuickOrder: {
            Fields: [],
        }
    };

    for (var i = 1; i <= limit; i++) {
        forms.QuickOrder.Fields.push({
            "Placeholder": 'Product Name or Part#',
            "Field": '#sku' + i,
            "Param": 'sku' + i,
            "Type": 'Text'
        },
        {
            "Placeholder": 'QTY',
            "Field": '#qty' + i,
            "Param": 'qty' + i,
            "Type": 'Text'
        });
    }

    function closeForm() {
        Roc.UI.closeForm("#hiddenBoxOrder");
    }

    function clearQuickOrderForm() {
        for (var i = 1; i <= limit; i++) {
            $('#sku' + i).val('');
            $('#qty' + i).val('');
        }
    }

    function clearForm() {
        Roc.Forms.clearFormInputs(".rocModule-content");
    }

    function openForm() { 
        Roc.UI.openForm("#hiddenBoxOrder");
        $(".addOrderField").html(($(".addOrderField").text() == "Add More Items To Your Order") ? "Hide More Items To Your Order" : "Add More Items To Your Order");
        //$('.quick-order-trigger').trigger('click');
        $('.header-links').find('.quick-order-link').next('li').find('a').focus();
    }

    function showOrderFieldEvt(callback) {
        $(document).on('click', '.addOrderField', function () { 
            openForm();
        });
    };


    function getTempAddressId() {
        return $('#hdnTempAddressId').val();
    }


    function submitFormEvt(callback) {
        $(document).on('click', '.addToCart', function () {
            Cart.CartSummary.init({
                showAddToCartModal: false
            });
            
            var data = Roc.Forms.getFormValues(forms.QuickOrder);
            if (!Roc.Validation.validateForm(forms.QuickOrder))
            { return false; }

            var viewModel = {};
            viewModel.Products = [];
            viewModel.CurrentOrderId = '{orderId}';

            for (var i = 1; i <= limit; i++) {
                if (data["sku" + i] !== "") {
                    viewModel.Products.push({ Sku: data["sku" + i], Qty: (data["qty" + i] !== "") ? data["qty" + i] : 1, ProductId: "" });
                }
            }

            if (viewModel.Products.length === 0) {
                //Roc.UI.info("You need to add product", "Information");
                Roc.UI.displayErrorPopup('You need to add product', 'Information');
                return false;
            }

            var tempAddressId = getTempAddressId(); 
            viewModel.tempAddressId = tempAddressId;
            Cart.CartLocker.isCartLocked().then(function () {
                Roc.UI.block("#quickOrderWrapper");
                $.proxyRequest({
                    url: '/api/schematics/order/quickOrder',
                    data: JSON.stringify(viewModel),
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json',
                    complete: function (resp) {
                        var data = resp.responseJSON || {};

                        if (resp.statusText === 'OK' && data.message === null) {
                            
                            $.each(viewModel.Products, function (index, element) {
                                if (_.find(data.addCartItemsResponse, function (product) {
                                    return product.sku.toLowerCase() === element.Sku.toLowerCase();
                                }) === null) {
                                    Roc.UI.error("Product " + element.Sku + " was not found", "Information");
                                } else {

                                    var skus = [];
                                    if (data.cart) {
                                    data.cart.items.forEach(function(item) {
                                            skus.push(item.sku);
                                        }
                                    );
                                    }
                                    //Roc.UI.info("Product " + element.Sku + " have been added to the cart", "Information");
                                    Roc.UI.displayErrorPopup('Product ' + skus + ' have been added to the cart', 'Information');
                                }
                            });
                            
                            Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, resp);
                            clearForm();
                            clearQuickOrderForm();
                            Roc.UI.unblock("#quickOrderWrapper");

                        } else {
                            clearForm();
                            Roc.UI.unblock("#quickOrderWrapper");
                            Roc.UI.error(data.message, "Information");
                        }
                    }
                });
            });
            return false;
        });
    };

    function bindEvents(callbacks) {
        var cbs = callbacks;

        showOrderFieldEvt(null);
        submitFormEvt(null);
    }

    function load() { 
       Roc.UI.template('quickOrder-Tmp', {
           'order': viewModel.Order
       }).then(function (renderedTemplate) { 
            $('#quickOrderWrapper').html(renderedTemplate);
        });
    }

    function init() {
        // window.RocConfig.api.baseRocApiUrl; 
        baseUrl = window.RocConfig.api.baseRocApiUrl;
        closeForm();
        bindEvents();
        load();
    };

    var QuickOrder = {
        init: init,
        order: viewModel.Order,
    };

    Roc.Logger.debug('QuickOrder.js Loaded:', QuickOrder);

    return QuickOrder;
});
